export { default } from './CheckDocuments.container';
